import { getIdFromGraphQLId } from '~/graphql_shared/utils';
import WorkItemAttribute from '../../../components/work_item_attribute.vue?vue3';
export default {
    name: 'IssuableMilestone',
    components: {
        WorkItemAttribute
    },
    props: {
        milestone: {
            type: Object,
            required: true
        }
    },
    computed: {
        milestoneLink () {
            return this.milestone.webPath || this.milestone.webUrl;
        },
        popoverAttributes () {
            return {
                'data-reference-type': 'milestone',
                'data-placement': 'top',
                'data-milestone': getIdFromGraphQLId(this.milestone.id)
            };
        }
    }
};
